import React from 'react';

import { useUser } from 'hooks/useAuth';
import { useAccount } from 'hooks/api/useAccount';
import { useAPI } from 'hooks/api/useAPI';
import { useCurrentOrganization } from 'hooks/api/useCurrentOrganization';
import { useCurrentPlan } from 'organizations/hooks/useCurrentPlan';
import {
  identifyGleapContact,
  setGleapWorkspaceContext,
} from 'services/gleap';

export function GleapProvider({ children }: React.PropsWithChildren) {
  const user = useUser();
  const { applicationID } = useAPI();
  const { data: organization } = useCurrentOrganization();
  const { data: currentPlan } = useCurrentPlan();
  const { data: account } = useAccount();

  const organizationId = organization?.id;
  const roles = account?.roles
    .filter(
      ({ application_id, organization_id }) =>
        application_id === applicationID || organization_id === organizationId
    )
    .map(({ name }) => name)
    ?.join(',');

  React.useEffect(() => {
    if (
      !user ||
      !user.id ||
      !user.email ||
      !organization ||
      !currentPlan ||
      !account ||
      !applicationID ||
      !roles
    ) {
      return;
    }

    try {
      setGleapWorkspaceContext(applicationID);
      identifyGleapContact(user.id, {
        email: user.email,
        name: user.name || user.email,
        companyId: organization.id,
        companyName: organization.name,
        plan: currentPlan.name,
        customData: {
          Role: roles,
          lumeo_workspace_id: applicationID,
        },
        ...(user.created_at
          ? { createdAt: new Date(user.created_at) }
          : undefined),
      });
    } catch (error) {
      console.error('Failed to identify Gleap contact:', error, user);
    }
  }, [user, organization, currentPlan, account, applicationID, roles]);

  return <>{children}</>;
}
